import { Check } from 'lucide-react'
import { Button } from 'components/Button'

const CompletionStep = ({ onNext }) => (
  <div className="w-full py-12 flex flex-col items-center justify-center space-y-5 animate-in fade-in slide-in-from-bottom-3 duration-500">
    <div className="relative flex items-center justify-center w-20 h-20">
      <div className="absolute inset-0 rounded-full bg-green-50 animate-pulse border border-green-100/50" />
      <div className="relative flex items-center justify-center w-14 h-14 rounded-full bg-green-500 text-white shadow-lg shadow-green-200/50">
        <Check size={24} className="stroke-[3]" />
      </div>
    </div>
    
    <div className="text-center space-y-2 max-w-sm">
      <h2 className="text-xl font-bold text-secondary-900 tracking-tight">All Set!</h2>
      <p className="text-xs text-secondary-500 leading-relaxed">
        Your treatment plan has been scheduled and all paperwork is complete. Thank you for choosing us for your dental care.
      </p>
    </div>

    <Button
      title="Finish"
      variant="tertiary"
      className='px-32'
      onClick={onNext}
    />
  </div>
)

export default CompletionStep
